export default __webpack_public_path__ + "static/media/filters-icon.f8116dd6.svg";